<script setup>
const route = useRoute();
const { showLoader } = useLoaderService();
const { gigyaLoadedPromise } = useGigyaManagerService();
const { navigateToDashboardApp } = useInterAppNavigationService();

definePageMeta({
  layout: 'user-reg-login-layout'
});

onBeforeMount(async () => {
  showLoader();
  if (!window.gigya) {
    await gigyaLoadedPromise();
  }
});

onMounted(async () => {
  if (
    route.query.errorCode == '403002' &&
    route.query.errorMessage.includes('link expired')
  ) {
    navigateTo({ path: '/verification-link-expired' });
  } else {
    !window.gigya && (await gigyaLoadedPromise());
    const userData = await useGigyaSession().getGigyaUserData();
    if (
      userData &&
      userData?.c1UserRole == 'teacher' &&
      userData?.data.eduelt.free_trialProductID?.length > 0
    ) {
      return navigateToDashboardApp([
        'teacher',
        'freetrial',
        'questionnaire',
        userData.data.eduelt.free_trialProductID
      ]);
    }
  }
});
</script>
